export default { 
    getAdmin: (state) => state.adminInfo,
    getAppStatuses: state => state.appStatuses,
};
